<div mat-dialog-title>
  {{ data.title }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <div class="container mt-2">
    <form [formGroup]="certificateForm">
      <div class="form-group row">
        <label for="courseName" class="col-4 col-sm-3 col-md-3 col-form-label">ชื่อ</label>
        <div class="col-8 col-sm-9 col-md-9">
          <input *ngIf="!checkUsername" type="text" class="form-control" id="name" formControlName="name"
            autocomplete="off">
          <input *ngIf="checkUsername" type="text" class="form-control" id="name" disabled autocomplete="off">
        </div>
      </div>
      <div class="form-group row">
        <label for="courseName" class="col-4 col-sm-3 col-md-3 col-form-label">นามสกุล</label>
        <div class="col-8 col-sm-9 col-md-9">
          <input *ngIf="!checkUsername" type="text" class="form-control" id="surname" formControlName="surname"
            autocomplete="off">
          <input *ngIf="checkUsername" type="text" class="form-control" id="surname" disabled autocomplete="off">
        </div>
      </div>
    </form>
    <mat-checkbox [(ngModel)]="checkUsername" (change)="createForm()" id="username" color="primary"
      class="form-control-plaintext">
      <span style="margin-left: 52px;">ใช้ชื่อผู้ใช้งาน ({{ data.USERNAME }})</span>
    </mat-checkbox>
  </div>
</mat-dialog-content>
<div mat-dialog-actions align="center" style="padding-bottom: 15px;">
  <button *ngIf="certificateForm.valid" (click)="createCertificate(certificateForm.value)" mat-button
    style="background: #3E8C1A; color: #fff;">
    สร้าง
  </button>
  <button *ngIf="!certificateForm.valid" mat-button [disabled]="true">
    สร้าง
  </button>
</div>
